var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "clearfix yxt-user-advance-wrap pr20" },
        [
          _c(
            "yxt-row",
            {
              staticClass: "mb16",
              attrs: { onsubmit: "return false", type: "flex" },
            },
            [
              _c(
                "yxt-form",
                { staticStyle: { flex: "1" }, attrs: { inline: true } },
                [
                  _c(
                    "div",
                    { staticClass: "d-in-flex" },
                    [
                      _c(
                        "yxt-popover",
                        {
                          attrs: {
                            "append-to-body": false,
                            "popper-class": "yxtbiz-user-selector-popover",
                            trigger: "manual",
                            placement: "bottom-start",
                            "visible-arrow": false,
                          },
                          model: {
                            value: _vm.showMoreFilter,
                            callback: function ($$v) {
                              _vm.showMoreFilter = $$v
                            },
                            expression: "showMoreFilter",
                          },
                        },
                        [
                          _c(
                            "yxt-button",
                            {
                              staticClass: "yxtbiz-filter-btn mr12 pull-left",
                              attrs: { slot: "reference", plain: "" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.showFilterBox.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                              slot: "reference",
                            },
                            [
                              _c("yxt-svg", {
                                staticClass: "v-top",
                                attrs: {
                                  width: "20px",
                                  height: "20px",
                                  "icon-class": "filter",
                                },
                              }),
                              _c("span", { staticClass: "ml8 v-top" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("pc_biz_udp_lbl_moreFilter"))
                                ),
                              ]),
                              _c("i", {
                                staticClass: "ml8",
                                class: _vm.showMoreFilter
                                  ? "yxt-icon-arrow-up"
                                  : "yxt-icon-arrow-down",
                              }),
                            ],
                            1
                          ),
                          _c(
                            "yxt-form",
                            {
                              staticClass: "yxtbiz-user-selector-filter",
                              attrs: { inline: true, "label-position": "top" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    width: "950px",
                                    "max-height": "600px",
                                    overflow: "auto",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "yxtbiz-user-selector-filter-box clearfix",
                                      staticStyle: { width: "950px" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "pl20 yxtbiz-user-selector-filter-right yxtbiz-user-selector-filter-block",
                                        },
                                        [
                                          _c(
                                            "yxt-row",
                                            { attrs: { gutter: 20 } },
                                            [
                                              _vm.isShowDeptment
                                                ? _c(
                                                    "yxt-col",
                                                    { attrs: { span: 12 } },
                                                    [
                                                      _c(
                                                        "yxt-form-item",
                                                        {
                                                          staticStyle: {
                                                            width: "100%",
                                                          },
                                                          attrs: {
                                                            label:
                                                              _vm.$t(
                                                                "biz_udp_deptment"
                                                              ),
                                                          },
                                                        },
                                                        [
                                                          _c("tree-select", {
                                                            staticStyle: {
                                                              width: "220px",
                                                            },
                                                            attrs: {
                                                              placeholder:
                                                                _vm.$t(
                                                                  "pc_biz_udp_lbl_unlimitedPosition"
                                                                ),
                                                            },
                                                            on: {
                                                              "remove-tag":
                                                                _vm.removeDept,
                                                            },
                                                            nativeOn: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.showTree(
                                                                  "dept-tree"
                                                                )
                                                              },
                                                            },
                                                            model: {
                                                              value: _vm.depts,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.depts =
                                                                    $$v
                                                                },
                                                              expression:
                                                                "depts",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "yxt-col",
                                                { attrs: { span: 12 } },
                                                [
                                                  _c(
                                                    "yxt-form-item",
                                                    {
                                                      staticStyle: {
                                                        width: "100%",
                                                      },
                                                      attrs: {
                                                        label:
                                                          _vm.$t(
                                                            "biz_udp_position"
                                                          ),
                                                      },
                                                    },
                                                    [
                                                      _c("tree-select", {
                                                        attrs: {
                                                          placeholder: _vm.$t(
                                                            "biz_udp_no_limit_pos"
                                                          ),
                                                        },
                                                        on: {
                                                          "remove-tag":
                                                            _vm.removePostion,
                                                        },
                                                        nativeOn: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.showPosition.apply(
                                                              null,
                                                              arguments
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value: _vm.positions,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.positions = $$v
                                                          },
                                                          expression:
                                                            "positions",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._l(
                                                _vm.selectedParams,
                                                function (item, index) {
                                                  return _c(
                                                    "yxt-col",
                                                    {
                                                      key: index,
                                                      attrs: { span: 12 },
                                                    },
                                                    [
                                                      _c(
                                                        "yxt-form-item",
                                                        {
                                                          staticStyle: {
                                                            width: "100%",
                                                          },
                                                          attrs: {
                                                            label: item.label,
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            [
                                                              _c(
                                                                item.component,
                                                                _vm._b(
                                                                  {
                                                                    tag: "component",
                                                                    attrs: {
                                                                      enableGroupCorp:
                                                                        _vm.enableGroupCorp,
                                                                      format:
                                                                        "yyyy-MM-dd",
                                                                      "value-format":
                                                                        "yyyy-MM-dd",
                                                                    },
                                                                    on: {
                                                                      input:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.itemChange(
                                                                            $event
                                                                          )
                                                                        },
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        item.data,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            item,
                                                                            "data",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "item.data",
                                                                    },
                                                                  },
                                                                  "component",
                                                                  item.props,
                                                                  false
                                                                )
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              _vm._l(
                                                _vm.spares,
                                                function (item, key) {
                                                  return _c("spare-item", {
                                                    key: "spareitem_" + key,
                                                    attrs: {
                                                      name: item.name,
                                                      type: item.patternType,
                                                      list: item.list,
                                                      value: item.patternValues,
                                                    },
                                                    on: {
                                                      "update:value": function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          item,
                                                          "patternValues",
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  })
                                                }
                                              ),
                                              _c(
                                                "yxt-col",
                                                { attrs: { span: 24 } },
                                                [
                                                  _c(
                                                    "yxt-form-item",
                                                    { attrs: { label: " " } },
                                                    [
                                                      _c(
                                                        "yxt-button",
                                                        {
                                                          attrs: {
                                                            type: "primary",
                                                          },
                                                          on: {
                                                            click:
                                                              _vm.filterSearch,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "pc_biz_udp_btn_determine"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "yxt-button",
                                                        {
                                                          staticClass: "mr8",
                                                          attrs: {
                                                            plain: "",
                                                            type: "default",
                                                          },
                                                          on: {
                                                            click:
                                                              _vm.closeFilterBox,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "pc_biz_udp_btn_cancel"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "yxt-button",
                                                        {
                                                          attrs: {
                                                            disabled:
                                                              _vm.saveDisabled,
                                                            type: "text",
                                                          },
                                                          on: {
                                                            click:
                                                              _vm.showFilter,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "pc_biz_udp_btn_saveToCommon"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            2
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm.enableGroupCorp
                        ? _c("yxtbiz-group-org-select", {
                            attrs: {
                              functionCode: _vm.functionCode,
                              dataPermissionCode: _vm.dataPermissionCode,
                              selectFirst: true,
                              clearable: false,
                              disabled: _vm.disabled,
                              setCurrentOrg: true,
                              targetOrgId: _vm.targetOrgId,
                              visibleOrgIds: _vm.visibleOrgIds,
                              disabledOrgIds: _vm.disabledOrgIds,
                            },
                            on: {
                              change: _vm.handleOrgChange,
                              orgInvalid: _vm.orgInvalidHandler,
                            },
                          })
                        : _vm._e(),
                      _c("yxt-input", {
                        staticClass: "ml12",
                        staticStyle: { width: "190px" },
                        attrs: {
                          placeholder: _vm.$t("pc_biz_udp_tip_searchCommon"),
                          searchable: "",
                        },
                        on: { search: _vm.search },
                        model: {
                          value: _vm.searchValue,
                          callback: function ($$v) {
                            _vm.searchValue = $$v
                          },
                          expression: "searchValue",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "div",
                { staticClass: "lh40" },
                [
                  _c(
                    "yxt-dropdown",
                    {
                      attrs: { "append-to-body": false, trigger: "click" },
                      on: { command: _vm.selectFilter },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "yxt-dropdown-link yxt-link yxt-link--primary",
                          on: { click: _vm.closeFilterBox },
                        },
                        [_vm._v(_vm._s(_vm.$t("pc_biz_udp_lbl_commonFilters")))]
                      ),
                      _c(
                        "yxt-dropdown-menu",
                        {
                          staticStyle: { overflow: "hidden" },
                          attrs: { slot: "dropdown" },
                          slot: "dropdown",
                        },
                        [
                          _vm.filterList.length === 0
                            ? _c(
                                "yxt-dropdown-item",
                                { attrs: { disabled: "" } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("pc_biz_udp_tip_noFilters"))
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._l(_vm.filterList, function (item) {
                            return _c(
                              "yxt-dropdown-item",
                              { key: item.id, attrs: { command: item } },
                              [
                                _c(
                                  "yxt-row",
                                  {
                                    staticClass: "yxt-selector-filter-row",
                                    staticStyle: { width: "100%" },
                                    attrs: { type: "flex", align: "middle" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "yxt-selector-filter-name",
                                      },
                                      [_c("span", [_vm._v(_vm._s(item.name))])]
                                    ),
                                    _c("span", {
                                      staticClass: "yxt-icon-close",
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.deleteFilter(item)
                                        },
                                      },
                                    }),
                                  ]
                                ),
                              ],
                              1
                            )
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "yxt-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "userTable",
              staticClass: "yxt-user-table",
              attrs: {
                height: _vm.tableHeight,
                "row-key": "id",
                data: _vm.users,
              },
              on: { "select-all": _vm.selectAllUser, select: _vm.selectUser },
            },
            [
              _c("template", { slot: "empty" }, [
                _c(
                  "div",
                  { staticStyle: { "line-height": "normal" } },
                  [_c("yxt-empty")],
                  1
                ),
              ]),
              _c("yxt-table-column", {
                attrs: {
                  "show-overflow-tooltip": false,
                  "class-name": "yxtbiz-table-selection",
                  type: "selection",
                  width: "40",
                },
              }),
              _c("yxt-table-column", {
                attrs: {
                  label: _vm.$t("pc_biz_core_lbl_name"),
                  "show-overflow-tooltip": true,
                  "popover-html": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.isOpenData
                          ? _c("yxtbiz-user-name", {
                              attrs: { name: scope.row.fullname },
                            })
                          : _c("span", [
                              _vm._v(
                                _vm._s(
                                  scope.row.fullname +
                                    "(" +
                                    scope.row.username +
                                    ")"
                                )
                              ),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("yxt-table-column", {
                attrs: {
                  "show-overflow-tooltip": true,
                  formatter: _vm.formatUserNo,
                  label: _vm.$t("pc_biz_core_lbl_userNo"),
                  prop: "userNo",
                },
              }),
              _c("yxt-table-column", {
                attrs: {
                  label: _vm.$t("pc_biz_core_lbl_department"),
                  "show-overflow-tooltip": true,
                  "popover-html": true,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        !scope.row.deptName
                          ? _c("span", [_vm._v("--")])
                          : _vm.isOpenData
                          ? _c("yxtbiz-dept-name", {
                              attrs: { name: scope.row.deptName },
                            })
                          : _c("span", [_vm._v(_vm._s(scope.row.deptName))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("yxt-table-column", {
                attrs: {
                  label: _vm.$t("biz_udp_position"),
                  "show-overflow-tooltip": true,
                  formatter: _vm.formatPostion,
                },
              }),
            ],
            2
          ),
          _c(
            "yxt-row",
            {
              staticClass: "yxtbiz-user-selector-mask mt16",
              attrs: { type: "flex", align: "middle" },
            },
            [
              _c(
                "yxt-row",
                {
                  staticClass: "col-flex-1",
                  attrs: { type: "flex", align: "middle" },
                },
                [
                  _vm.showFilterAll
                    ? _c(
                        "yxt-button",
                        {
                          staticClass: "lh32 yxtbiz-btn-search-all",
                          class: _vm.isSearchAll
                            ? "color-primary-4 disabled"
                            : "",
                          attrs: { type: "text" },
                          on: { click: _vm.searchAll },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.isCancelSelect
                                ? _vm.$t("pc_biz_udp_btn_cancelFilter")
                                : _vm.$t("biz_udp_all_filter_results")
                            )
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c("div", {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.isSearchAll,
                        expression: "isSearchAll",
                      },
                    ],
                    staticClass: "yxtbiz-loading__all",
                  }),
                ],
                1
              ),
              _c("yxt-pagination", {
                staticClass: "pull-right",
                attrs: {
                  "current-page": _vm.page,
                  "page-size": _vm.userData.limit,
                  "simple-total": "",
                  layout: "total, prev, pager, next",
                  total: _vm.count,
                },
                on: {
                  "size-change": _vm.sizeChange,
                  "current-change": _vm.pageChange,
                  "update:currentPage": function ($event) {
                    _vm.page = $event
                  },
                  "update:current-page": function ($event) {
                    _vm.page = $event
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "yxt-drawer",
        {
          attrs: {
            title: _vm.$t("pc_biz_udp_tit_saveFilter"),
            modal: false,
            visible: _vm.dialogVisible,
            size: "480px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "yxt-form",
            [
              _c(
                "yxt-form-item",
                {
                  attrs: {
                    "label-width": "80px",
                    label: _vm.$t("pc_biz_udp_lbl_filterName"),
                  },
                },
                [
                  _c("yxt-input", {
                    attrs: { maxlength: "100" },
                    model: {
                      value: _vm.filerName,
                      callback: function ($$v) {
                        _vm.filerName = $$v
                      },
                      expression: "filerName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "yxt-button",
                {
                  attrs: { plain: "" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("pc_biz_udp_btn_cancel")))]
              ),
              _c(
                "yxt-button",
                { attrs: { type: "primary" }, on: { click: _vm.saveFilter } },
                [_vm._v(_vm._s(_vm.$t("pc_biz_udp_btn_confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "yxt-drawer",
        {
          attrs: {
            title: _vm.$t("biz_udp_select_dept"),
            "destroy-on-close": true,
            size: "480px",
            visible: _vm.drawerVisible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawerVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "yxtbiz-dept-tree-full-height" },
            [
              _c(
                _vm.component,
                _vm._b(
                  {
                    ref: "tree",
                    tag: "component",
                    attrs: {
                      enableGroupCorp: true,
                      targetOrgId: _vm.userData.targetOrgId,
                      visibleOrgSelector: false,
                    },
                  },
                  "component",
                  _vm.treeProps,
                  false
                )
              ),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "yxt-button",
                { attrs: { plain: "" }, on: { click: _vm.cancelTree } },
                [_vm._v(_vm._s(_vm.$t("pc_biz_udp_btn_cancel")))]
              ),
              _c(
                "yxt-button",
                { attrs: { type: "primary" }, on: { click: _vm.confirmTree } },
                [_vm._v(_vm._s(_vm.$t("pc_biz_udp_btn_confirm")))]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "yxt-drawer",
        {
          attrs: {
            title: _vm.$t("pc_biz_udp_tit_selectPotision"),
            visible: _vm.positionVisible,
            "destroy-on-close": true,
            size: "960px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.positionVisible = $event
            },
          },
        },
        [
          _vm.enableGroupCorp && _vm.userData.targetOrgId
            ? _c("yxtbiz-check-person-range", {
                attrs: {
                  targetOrgId: _vm.userData.targetOrgId,
                  enableGroupCorp: true,
                  visibleOrgSelector: false,
                  personRange: _vm.selectedPositions,
                  functionCode: _vm.functionCode,
                  dataPermissionCode: _vm.dataPermissionCode,
                  tabs: ["position"],
                },
                on: {
                  "update:personRange": function ($event) {
                    _vm.selectedPositions = $event
                  },
                  "update:person-range": function ($event) {
                    _vm.selectedPositions = $event
                  },
                },
              })
            : _vm._e(),
          !_vm.enableGroupCorp
            ? _c("yxtbiz-check-person-range", {
                attrs: {
                  personRange: _vm.selectedPositions,
                  functionCode: _vm.functionCode,
                  dataPermissionCode: _vm.dataPermissionCode,
                  tabs: ["position"],
                },
                on: {
                  "update:personRange": function ($event) {
                    _vm.selectedPositions = $event
                  },
                  "update:person-range": function ($event) {
                    _vm.selectedPositions = $event
                  },
                },
              })
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "yxt-button",
                {
                  attrs: { plain: "" },
                  on: {
                    click: function ($event) {
                      _vm.positionVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("pc_biz_udp_btn_cancel")))]
              ),
              _c(
                "yxt-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.closePosition },
                },
                [_vm._v(_vm._s(_vm.$t("pc_biz_udp_btn_confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }